import React from 'react';

import { Box, List, Typography } from '@material-ui/core';

import { Player } from 'services/api/definitions/game.definitions';

import LeaderboardListItem from './LeaderboardListItem';

interface Props {
  title: string;
  body: string;
  players: Player[];
  currentUser?: string;
}

const LeaderboardSection = ({ players, title, body, currentUser }: Props) => {
  const youIdx = players.findIndex(p => p.id === currentUser);
  let prevUserId = youIdx > 0 ? players[youIdx - 1].id : undefined;

  return (
    <>
      <Box mx={4}>
        <Typography variant="h6" component="h2" color="textPrimary">
          {title}
        </Typography>
        <Box my={1}>
          <Typography variant="body1" color="textSecondary">
            {body}
          </Typography>
        </Box>
      </Box>
      <List disablePadding>
        {players.map(({ username, avatar, rank, points, id }) => (
          <LeaderboardListItem
            key={username}
            name={username}
            score={points}
            imageUrl={avatar}
            position={rank}
            isYou={id === currentUser}
            divider={id !== prevUserId && id !== currentUser}
          />
        ))}
      </List>
    </>
  );
};

export default LeaderboardSection;
